module.exports = __webpack_public_path__ + "img/wu.a4eb8154.png";